/* Give keyboard access to existing cookie-table scrolling without rewriting its data. */
(()=>{const init=()=>document.querySelectorAll('main .legal-page .table-scroller').forEach(el=>{
 const table=el.querySelector('table');if(!table)return;
 const label=table.getAttribute('aria-label')||table.querySelector('caption')?.textContent?.trim()||table.closest('.legal-section')?.querySelector('h2,h3')?.textContent?.trim()||document.querySelector('main h1')?.textContent?.trim();
 if(label){el.setAttribute('role','region');el.setAttribute('aria-label',label);}
 el.setAttribute('tabindex','0');
});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();})();
